"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.native = void 0;
exports.native = {
    info: {
        key: 'native',
        title: 'Native JSON',
        link: 'https://www.json.org/json-en.html',
        description: 'A JSON represetation of any HAR payload.',
    },
    convert: function (_a, inputOpts) {
        var postData = _a.postData;
        var opts = __assign({ indent: '  ' }, inputOpts);
        var payload = '';
        switch (postData.mimeType) {
            case 'application/x-www-form-urlencoded':
                payload = postData.paramsObj ? postData.paramsObj : postData.text;
                break;
            case 'application/json':
                if (postData.jsonObj) {
                    payload = postData.jsonObj;
                }
                break;
            case 'multipart/form-data':
                if (!postData.params) {
                    break;
                }
                // eslint-disable-next-line no-case-declarations
                var multipartPayload_1 = {};
                postData.params.forEach(function (param) {
                    multipartPayload_1[param.name] = param.value;
                });
                payload = multipartPayload_1;
                break;
            default:
                if (postData.text) {
                    payload = postData.text;
                }
        }
        if (typeof payload === undefined || payload === '') {
            return 'No JSON body';
        }
        return JSON.stringify(payload, null, opts.indent);
    },
};
